<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <b-card no-body v-if="item">
      <b-tabs card>
        <b-tab title="Options" active>
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="tags"
          >
            <o-tag-input
              v-if="item && item.tags"
              :form-state="formState"
              :server-errors="_se"
              :validators="$v.item"
              name="tags"
              v-bind="schema.fields.tags"
              v-model="item.tags"
            ></o-tag-input>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_show_qr_code"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_qr_code"
              :form-state="formState"
              name="option_show_qr_code"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_qr_code"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_keep_score"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_keep_score"
              :form-state="formState"
              name="option_keep_score"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_keep_score"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_has_tags"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_has_tags"
              :form-state="formState"
              name="option_has_tags"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_has_tags"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_must_sign_off"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_must_sign_off"
              :form-state="formState"
              name="option_must_sign_off"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_must_sign_off"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_sign_off_message"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
            v-if="item.option_must_sign_off"
          >
            <o-text-field
              v-model="item.option_sign_off_message"
              :form-state="formState"
              name="option_sign_off_message"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_sign_off_message"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_multiple_sign_offs"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
            v-if="item.option_must_sign_off"
          >
            <o-checkbox
              v-model="item.option_multiple_sign_offs"
              :form-state="formState"
              name="option_multiple_sign_offs"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_multiple_sign_offs"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item"
            name="option_form_is_submitted"
          >
            <o-checkbox
              :form-state="formState"
              :server-errors="_se"
              :validators="$v.item"
              name="option_form_is_submitted"
              v-bind="schema.fields.option_form_is_submitted"
              v-model="item.option_form_is_submitted"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_lock_on_submit"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_lock_on_submit"
              :form-state="formState"
              name="option_lock_on_submit"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_lock_on_submit"
            ></o-checkbox>
          </o-widget-wrapper>

        </b-tab>
        <b-tab title="Buttons">
 <o-widget-wrapper
            :schema="schema"
            name="option_hide_and_close_button"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_hide_and_close_button"
              :form-state="formState"
              name="option_hide_and_close_button"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_hide_and_close_button"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_hide_and_new_button"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_hide_and_new_button"
              :form-state="formState"
              name="option_hide_and_new_button"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_hide_and_new_button"
            ></o-checkbox>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_hide_delete_button"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_hide_delete_button"
              :form-state="formState"
              name="option_hide_delete_button"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_hide_delete_button"
            ></o-checkbox>
          </o-widget-wrapper>

          <hr />
          <h5>Button Labels</h5>

          <o-widget-wrapper
            :schema="schema"
            name="option_create_button_label"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.option_create_button_label"
              :form-state="formState"
              name="option_create_button_label"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_create_button_label"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="option_update_button_label"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.option_update_button_label"
              :form-state="formState"
              name="option_update_button_label"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_update_button_label"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            v-if="item.option_form_is_submitted"
            :schema="schema"
            name="option_submit_button_label"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.option_submit_button_label"
              :form-state="formState"
              name="option_submit_button_label"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_submit_button_label"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            v-if="!item.option_hide_and_close_button"
            :schema="schema"
            name="option_and_close_suffix"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.option_and_close_suffix"
              :form-state="formState"
              name="option_and_close_suffix"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_and_close_suffix"
            ></o-text-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            v-if="!item.option_hide_and_new_button"
            :schema="schema"
            name="option_and_new_suffix"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.option_and_new_suffix"
              :form-state="formState"
              name="option_and_new_suffix"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_and_new_suffix"
            ></o-text-field>
          </o-widget-wrapper>
        </b-tab>
        <b-tab title="Print">
          <o-widget-wrapper
            :schema="schema"
            name="option_show_print_start"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_print_start"
              :form-state="formState"
              name="option_show_print_start"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_print_start"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_print_end"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_print_end"
              :form-state="formState"
              name="option_show_print_end"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_print_end"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_created_user"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_created_user"
              :form-state="formState"
              name="option_show_created_user"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_created_user"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_created_date"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_created_date"
              :form-state="formState"
              name="option_show_created_date"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_created_date"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_modified_user"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_modified_user"
              :form-state="formState"
              name="option_show_modified_user"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_modified_user"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_modified_date"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_modified_date"
              :form-state="formState"
              name="option_show_modified_date"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_modified_date"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_submitted_user"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_submitted_user"
              :form-state="formState"
              name="option_show_submitted_user"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_submitted_user"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_submitted_date"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_submitted_date"
              :form-state="formState"
              name="option_show_submitted_date"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_submitted_date"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_current_status"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_current_status"
              :form-state="formState"
              name="option_show_current_status"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_current_status"
            ></o-checkbox>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="option_show_who"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.option_show_who"
              :form-state="formState"
              name="option_show_who"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.option_show_who"
            ></o-checkbox>
          </o-widget-wrapper>
        </b-tab>
        <b-tab title="Design">
          <o-widget-wrapper
            :schema="schema"
            name="fields"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <f-template
              :design="true"
              :fields="item.fields"
              :form-state="formState"
              @fields-change="fieldsChanged"
              :form-context="formContext"
              v-model="item.data"
            ></f-template>
          </o-widget-wrapper>
        </b-tab>
        <b-tab title="Preview" @click="resetPreviewData">
          <f-template
            v-model="preview_data"
            :fields="item.fields"
            :design="false"
            :form-state="formState"
          ></f-template>
        </b-tab>
        <b-tab title="Workflow">
          <o-widget-wrapper
            :schema="schema"
            name="workflow_script"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-code-mirror
              v-model="item.workflow_script"
              :form-state="formState"
              name="workflow_script"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.workflow_script"
            />

            <button class="btn btn-info" @click="check_syntax">
              Check Syntax
            </button>
            <div id="syntax-errors" v-if="syntax">
              <div class="alert alert-success" v-if="syntax.ok">
                Code is Good. Number of States: {{ syntax.numberOfStates }}
              </div>
              <div
                v-for="(error, index) in syntax.errors"
                :key="index"
                class="alert alert-danger"
              >
                {{ error }}
              </div>

              <div
                v-for="(warning, index) in syntax.warnings"
                :key="index"
                class="alert alert-warning"
              >
                {{ warning }}
              </div>
            </div>
          </o-widget-wrapper>
        </b-tab>
        <b-tab class="p-0" title="Permissions">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :validators="$v.item.group_permissions"
            name="group_permissions"
          >
            <form-template-permission-form-table
              :form-state="formState"
              :label="schema.fields.group_permissions.label"
              :level="level + 1"
              :server-errors="_se.group_permissions"
              :validators="$v.item.group_permissions"
              v-model="item.group_permissions"
            >
            </form-template-permission-form-table>
          </o-widget-wrapper>
        </b-tab>
        <b-tab title="Outline">
          <div>
            <h4 @click="toggleOutlineJson" style="cursor: pointer">
              Outline of Form
            </h4>
            <fields-outline
              :fields="item.fields"
              @fields-change="fieldsChanged"
            />
            <textarea
              v-if="show_outline_json"
              class="json-preview w-100"
              rows="10"
              v-model="outline_json"
            ></textarea>
            <button
              v-if="show_outline_json"
              class="btn btn-primary"
              @click="updateFieldsFromJson"
            >
              Update
            </button>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </o-form-wrapper>
</template>

<script>
import _ from "lodash";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper.vue";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField.vue";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox.vue";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper.vue";
import OTagInput from "@/vue-ocom/components/forms/fields/OTagInput.vue";
import OCodeMirror from "./OCodeMirror.vue";
import FieldsOutline from "./FieldsOutline.vue";

import { default as FormTemplatePermissionFormTable } from "../../form_template_permission/components/ItemFormTable.vue";

import ItemsEditor from "../../components/ItemsEditor.vue";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("FormTemplateVersion"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    OCheckbox,
    OTextField,
    OTagInput,
    ItemsEditor,
    FieldsOutline,
    FormTemplatePermissionFormTable,
    OCodeMirror,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
  },
  data() {
    return {
      schemaModel: cleanUpModel(schema.FormTemplateVersion, {}),
      preview_data: {},
      syntax: null,
      show_outline_json: false,
      outline_json: "",
    };
  },
  methods: {
    toggleOutlineJson() {
      this.show_outline_json = !this.show_outline_json;
      this.outline_json = JSON.stringify(this.item.fields, null, 2);
    },
    updateFieldsFromJson() {
      var newFields = JSON.parse(this.outline_json);
      this.fieldsChanged(newFields);
    },
    fieldsChanged(fields) {
      this.item.fields = fields;
      this.item._changed = true;

      if (this.validator) {
        this.validator.$touch();
      }
      if (this.formState) this.formState.dirty = true;
    },
    resetPreviewData() {
      this.preview_data = {};
    },
    check_syntax() {
      const vm = this;
      this.syntax = null; // clear so we can see it changed

      var data = { script: this.item.workflow_script };
      axios
        .post("/forms247/v1/check/", data)
        .then((data) => {
          vm.syntax = data["data"];
        })
        .catch((error) => {
          vm.showMessage({
            message: "An error occurred:" + error.response.data.error,
            type: "danger",
            show: true,
          });
        });
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    formContext() {
      return {
        states: {}, // nothing
      };
    },
  },
  watch: {
    "item.option_show_print_start": {
      handler(newVal, oldVal) {
        this.item.option_show_print_end = !newVal;
      },
    },
    "item.option_show_print_end": {
      handler(newVal, oldVal) {
        this.item.option_show_print_start = !newVal;
      },
    },
  },
};
</script>
